import ReplaceText from 'core/display/composite/ReplaceText'
import { signal } from 'services/SignalsService'

export default class RTPText extends ReplaceText{
  constructor(data) {
    super(data)

    signal.once('ACTION:SETUP', this.update.bind(this))
  }

  update() {
    this.replace(game.models.GameModel.RTP)
  }
}
